import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Alert from "../../Common/Alert";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import ReactDataTable from "../../Common/ReactDataTable";

import useAlertFromLocation from "../../../hooks/useAlertFromLocation";
import useDeleteData from "../../../hooks/useDeleteData";
import { mergedOrderNos } from "./mergeItems";

const List = () => {
  const [receiveData, setReceiveData] = useState([]);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(false);

  const alert = useAlertFromLocation();

  const fetchData = async () => {
    setLoading(true);
    try {
      const [res1, res2] = await Promise.all([Http.get("/merge-invoice"), Http.get("/staff-type-check")]);
      setReceiveData(res1.data);
      setRole(res2.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteData = useDeleteData(fetchData);

  const cols = [
    { field: "date", header: "Date" },
    { field: "receipt_no", header: "Merge No" },
    { field: (item) => (item.distributor ? item.distributor.name : ""), header: "Distributor" },
    { field: (item) => mergedOrderNos(item), header: "Invoice Nos" },
    { field: "vehicle_number", header: "Vehicle" },
    { field: (item) => (item.created_by ? item.created_by.name : ""), header: "Created By" },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Merge Invoices</h5>
            <Link to="/create-merge-invoice" className="btn btn-primary">
              <i className="fa fa-plus-square mg-r-6"></i> Merge Invoice
            </Link>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <ReactDataTable
                  cols={cols}
                  receiveData={receiveData}
                  isLoading={loading}
                  actionTemplate={actionTemplate}
                  deleteData={deleteData}
                  role={role}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const actionTemplate = (rowData, deleteData, role) => {
  return (
    <div className="text-xs text-nowrap">
      <Link to={{ pathname: "/merge-invoice-receipt/" + rowData.id }} className="btn btn-info btn-sm" title="Receipt">
        <i className="fa fa-list" aria-hidden="true"></i>
      </Link>
      <Link to={{ pathname: "/merge-invoice-chalan/" + rowData.id }} className="btn btn-secondary btn-sm ms-1" title="Challan">
        <i className="fa fa-truck" aria-hidden="true"></i>
      </Link>
      <Link to={{ pathname: "/merge-invoice-mushak/" + rowData.id }} className="btn btn-success btn-sm ms-1" title="Mushak 6.3">
        <i className="fa fa-file-text-o" aria-hidden="true"></i>
      </Link>
      {role === "admin" && (
        <button className="btn btn-danger btn-sm ms-1" onClick={() => deleteData(rowData.id, "merge-invoice", "merge invoice")} title="Delete">
          <i className="fa fa-trash"></i>
        </button>
      )}
    </div>
  );
};

export default List;
